import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Heading: ComponentStyleConfig = {
  variants: {
    h1: {},
    h2: {
      fontSize: '16px',
      fontWeight: 600,
    },
    h3: {
      fontSize: '14px',
      textTransform: 'uppercase',
      fontWeight: 600,
    },
  },
  defaultProps: {
    variant: 'h3',
  },
};
